/**
 * Step-by-Step's next step between status refreshes.
 *
 * Breakfast / Lunch / Dinner follow the sequence, skipping slots already
 * planned. A Snack step is NEVER decided from local calorie arithmetic, and
 * never from Snack AVAILABILITY alone: the backend owns two separate facts on
 * GET /guided-planning/status (and POST /guided-planning/meals):
 *
 *   can_add_snacks / snack_available   another (different) Snack is
 *       nutritionally safe to add -- an OPTIONAL choice (Overview "+ Add").
 *   guided_snack_step                  Guided Planning should actively send the
 *       user into a Snack step now: primary structure complete, the saved day
 *       is NOT Within Range, an eligible Snack reaches range or meaningfully
 *       improves the day, and fewer than the guided limit (2) Snacks are saved.
 *
 * Only guided_snack_step moves the flow into a Snack step.
 *
 *   afterAdd  the saved day just changed: the facts in hand are for the day
 *             BEFORE the add, so once no primary slot is left the refreshed
 *             status decides (awaitStatus) -- a Snack step, or the day is done.
 *   skip      the saved day did not change: the status in hand still holds.
 *
 * Returns { nextType, awaitStatus }; nextType null with awaitStatus false
 * means the day is done.
 */
export var GUIDED_SEQUENCE = ['Breakfast', 'Lunch', 'Dinner', 'Snack'];

/** Another Snack may optionally be added (availability, not navigation). */
export function snackAvailable(status) {
  return !!(status && status.can_add_snacks === true);
}

/** The backend's Guided flow decision: enter a Snack step now. */
export function guidedSnackStep(status) {
  return !!(status && status.guided_snack_step === true);
}

/**
 * { meal_id: true } for the saved day's pending, non-leftover Snacks. Picking
 * one of these again for the Snack step is refused: the add path would
 * collapse it into (and reset) the saved one.
 */
export function pendingSnackMealIds(rows) {
  var ids = {};
  (Array.isArray(rows) ? rows : []).forEach(function (p) {
    if (p.meal_type === 'Snack' && p.status === 'pending' && !p.leftover_group_id && p.meal_id) ids[p.meal_id] = true;
  });
  return ids;
}

export function nextGuidedStep(currentType, status, opts) {
  var afterAdd = !!(opts && opts.afterAdd);
  var planned = (status && status.planned_meal_types) || [];
  var start = GUIDED_SEQUENCE.indexOf(currentType) + 1;
  for (var i = start; i < GUIDED_SEQUENCE.length; i++) {
    var type = GUIDED_SEQUENCE[i];
    if (type === 'Snack') break;
    if (planned.indexOf(type) === -1) return { nextType: type, awaitStatus: false };
  }
  // No primary slot left after this step.
  if (afterAdd) return { nextType: null, awaitStatus: true };
  if (currentType !== 'Snack' && guidedSnackStep(status)) return { nextType: 'Snack', awaitStatus: false };
  return { nextType: null, awaitStatus: false };
}
